import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../translation/translation_container';
import { LightboxView } from './view_sections/lightbox_view';
import { LightboxViewHeadline } from './view_sections/lightbox_view_headline';
import { LightboxViewContent } from './view_sections/lightbox_view_content';
import { LightboxViewAction } from './view_sections/view_actions/lightbox_view_action';
import { LightboxFilterCheckbox } from './filters/lightbox_filter_checkbox';
import { FilterSections } from '../../../../constants/filter/filter_sections';
import { Filters } from '../../../../constants/filter/filters';
import { FilterSectionLabelTranslationKeys } from '../../../../constants/filter/filter_section_label_translation_keys';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';

function LightboxDeals(props) {
    const sectionHeadlineTranslationKey = FilterSectionLabelTranslationKeys[FilterSections.DEALS_VIEW];
    const buy4Pay3TranslationKey = FilterLabelTranslationKeys[Filters.BUY_4_PAY_3];
    const clearanceTranslationKey = FilterLabelTranslationKeys[Filters.CLEARANCE];
    const instantCashTranslationKey = FilterLabelTranslationKeys[Filters.INSTANT_CASH];

    return (
        <LightboxView
            viewName={FilterSections.DEALS_VIEW}
            opened={props.opened}
        >
            <TranslationContainer translationKey={sectionHeadlineTranslationKey} targetProperty="headline">
                <LightboxViewHeadline headline="will-be-replaced" />
            </TranslationContainer>

            <LightboxViewContent>
                {props.freeFittingEnabled &&
                    <LightboxFilterCheckbox
                        name={Filters.FREE_FITTING}
                        checked={props.freeFittingValue}
                        labelTranslationKey={FilterLabelTranslationKeys[Filters.FREE_FITTING]}
                        onChange={props.onChange}
                        disabled={!props.freeFittingEnabled}
                    />
                }
                <LightboxFilterCheckbox
                    name={Filters.BUY_4_PAY_3}
                    checked={props.buy4Pay3Value}
                    labelTranslationKey={buy4Pay3TranslationKey}
                    onChange={props.onChange}
                    disabled={!props.buy4Pay3Enabled}
                />

                <LightboxFilterCheckbox
                    name={Filters.CLEARANCE}
                    checked={props.clearanceValue}
                    labelTranslationKey={clearanceTranslationKey}
                    onChange={props.onChange}
                    disabled={!props.clearanceEnabled}
                />

    {props.discountInstantCash50Enabled &&
        <LightboxFilterCheckbox
            name={Filters.DISCOUNT_INSTANT_CASH_50}
            checked={props.discountInstantCash50Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_50]}
            onChange={props.onChange}
            disabled={!props.discountInstantCash50Enabled}
        />
    }

    {props.discountInstantCash80Enabled &&
        <LightboxFilterCheckbox
            name={Filters.DISCOUNT_INSTANT_CASH_80}
            checked={props.discountInstantCash80Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_80]}
            onChange={props.onChange}
            disabled={!props.discountInstantCash80Enabled}
        />
    }

    {props.discountInstantCash100Enabled &&
        <LightboxFilterCheckbox
            name={Filters.DISCOUNT_INSTANT_CASH_100}
            checked={props.discountInstantCash100Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_100]}
            onChange={props.onChange}
            disabled={!props.discountInstantCash100Enabled}
        />
    }

    {props.discountInstantCash120Enabled &&
        <LightboxFilterCheckbox
            name={Filters.DISCOUNT_INSTANT_CASH_120}
            checked={props.discountInstantCash120Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_120]}
            onChange={props.onChange}
            disabled={!props.discountInstantCash120Enabled}
        />
    }

    {props.discountInstantCash150Enabled &&
        <LightboxFilterCheckbox
            name={Filters.DISCOUNT_INSTANT_CASH_150}
            checked={props.discountInstantCash150Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_150]}
            onChange={props.onChange}
            disabled={!props.discountInstantCash150Enabled}
        />
    }
    {props.discountInstantCash160Enabled &&
        <LightboxFilterCheckbox
            name={Filters.DISCOUNT_INSTANT_CASH_160}
            checked={props.discountInstantCash160Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_160]}
            onChange={props.onChange}
            disabled={!props.discountInstantCash160Enabled}
        />
    }

    {props.discountInstantCash200Enabled &&
        <LightboxFilterCheckbox
            name={Filters.DISCOUNT_INSTANT_CASH_200}
            checked={props.discountInstantCash200Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_200]}
            onChange={props.onChange}
            disabled={!props.discountInstantCash200Enabled}
        />
    }

    {props.discountInstantCash250Enabled &&
        <LightboxFilterCheckbox
            name={Filters.DISCOUNT_INSTANT_CASH_250}
            checked={props.discountInstantCash250Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_250]}
            onChange={props.onChange}
            disabled={!props.discountInstantCash250Enabled}
        />
    }

    {props.discountInstantCash300Enabled &&
        <LightboxFilterCheckbox
            name={Filters.DISCOUNT_INSTANT_CASH_300}
            checked={props.discountInstantCash300Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_INSTANT_CASH_300]}
            onChange={props.onChange}
            disabled={!props.discountInstantCash300Enabled}
        />
    }

    {props.discount5OffEnabled &&
        <LightboxFilterCheckbox
            name={Filters.DISCOUNT_5_OFF}
            checked={props.discount5OffValue}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_5_OFF]}
            onChange={props.onChange}
            disabled={!props.discount5OffEnabled}
        />
    }

    {props.discount10OffEnabled &&
        <LightboxFilterCheckbox
            name={Filters.DISCOUNT_10_OFF}
            checked={props.discount10OffValue}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_10_OFF]}
            onChange={props.onChange}
            disabled={!props.discount10OffEnabled}
        />
    }

    {props.discount15OffEnabled &&
        <LightboxFilterCheckbox
            name={Filters.DISCOUNT_15_OFF}
            checked={props.discount15OffValue}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_15_OFF]}
            onChange={props.onChange}
            disabled={!props.discount15OffEnabled}
        />
    }

    {props.discount20OffEnabled &&
        <LightboxFilterCheckbox
            name={Filters.DISCOUNT_20_OFF}
            checked={props.discount20OffValue}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_20_OFF]}
            onChange={props.onChange}
            disabled={!props.discount20OffEnabled}
        />
    }

    {props.discount25OffEnabled &&
        <LightboxFilterCheckbox
            name={Filters.DISCOUNT_25_OFF}
            checked={props.discount25OffValue}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.DISCOUNT_25_OFF]}
            onChange={props.onChange}
            disabled={!props.discount25OffEnabled}
        />
    }

    {props.promoGiftCard50Enabled &&
        <LightboxFilterCheckbox
            name={Filters.PROMO_GIFT_CARD_50}
            checked={props.promoGiftCard50Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.PROMO_GIFT_CARD_50]}
            onChange={props.onChange}
            disabled={!props.promoGiftCard50Enabled}
        />
    }

    {props.promoGiftCard80Enabled &&
        <LightboxFilterCheckbox
            name={Filters.PROMO_GIFT_CARD_80}
            checked={props.promoGiftCard80Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.PROMO_GIFT_CARD_80]}
            onChange={props.onChange}
            disabled={!props.promoGiftCard80Enabled}
        />
    }

    {props.promoGiftCard100Enabled &&
        <LightboxFilterCheckbox
            name={Filters.PROMO_GIFT_CARD_100}
            checked={props.promoGiftCard100Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.PROMO_GIFT_CARD_100]}
            onChange={props.onChange}
            disabled={!props.promoGiftCard100Enabled}
        />
    }

    {props.promoGiftCard130Enabled &&
        <LightboxFilterCheckbox
            name={Filters.PROMO_GIFT_CARD_130}
            checked={props.promoGiftCard130Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.PROMO_GIFT_CARD_130]}
            onChange={props.onChange}
            disabled={!props.promoGiftCard130Enabled}
        />
    }

    {props.promoGiftCard150Enabled &&
        <LightboxFilterCheckbox
            name={Filters.PROMO_GIFT_CARD_150}
            checked={props.promoGiftCard150Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.PROMO_GIFT_CARD_150]}
            onChange={props.onChange}
            disabled={!props.promoGiftCard150Enabled}
        />
    }

    {props.promoGiftCard200Enabled &&
        <LightboxFilterCheckbox
            name={Filters.PROMO_GIFT_CARD_200}
            checked={props.promoGiftCard200Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.PROMO_GIFT_CARD_200]}
            onChange={props.onChange}
            disabled={!props.promoGiftCard200Enabled}
        />
    }

    {props.promoGiftCard250Enabled &&
        <LightboxFilterCheckbox
            name={Filters.PROMO_GIFT_CARD_250}
            checked={props.promoGiftCard250Value}
            labelTranslationKey={FilterLabelTranslationKeys[Filters.PROMO_GIFT_CARD_250]}
            onChange={props.onChange}
            disabled={!props.promoGiftCard250Enabled}
        />
    }

            </LightboxViewContent>

            <LightboxViewAction
                onCloseClick={props.resetSection}
                onSaveClick={props.saveSection}
            />
        </LightboxView>
    );
}

LightboxDeals.propTypes = {
    freeFittingValue: PropTypes.bool.isRequired,
    buy4Pay3Value: PropTypes.bool.isRequired,
    clearanceValue: PropTypes.bool.isRequired,
    instantCashValue: PropTypes.bool.isRequired,
    freeFittingEnabled: PropTypes.bool.isRequired,
    buy4Pay3Enabled: PropTypes.bool.isRequired,
    clearanceEnabled: PropTypes.bool.isRequired,
    instantCashEnabled: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    resetSection: PropTypes.func.isRequired,
    saveSection: PropTypes.func.isRequired,
    opened: PropTypes.bool.isRequired,

    discountInstantCash50Value: PropTypes.bool.isRequired,
    discountInstantCash80Value: PropTypes.bool.isRequired,
    discountInstantCash100Value: PropTypes.bool.isRequired,
    discountInstantCash120Value: PropTypes.bool.isRequired,
    discountInstantCash150Value: PropTypes.bool.isRequired,
    discountInstantCash160Value: PropTypes.bool.isRequired,
    discountInstantCash200Value: PropTypes.bool.isRequired,
    discountInstantCash250Value: PropTypes.bool.isRequired,
    discountInstantCash300Value: PropTypes.bool.isRequired,
    discount5OffValue: PropTypes.bool.isRequired,
    discount10OffValue: PropTypes.bool.isRequired,
    discount15OffValue: PropTypes.bool.isRequired,
    discount20OffValue: PropTypes.bool.isRequired,
    discount25OffValue: PropTypes.bool.isRequired,
    promoGiftCard50Value: PropTypes.bool.isRequired,
    promoGiftCard80Value: PropTypes.bool.isRequired,
    promoGiftCard100Value: PropTypes.bool.isRequired,
    promoGiftCard130Value: PropTypes.bool.isRequired,
    promoGiftCard150Value: PropTypes.bool.isRequired,
    promoGiftCard200Value: PropTypes.bool.isRequired,
    promoGiftCard250Value: PropTypes.bool.isRequired,
    discountInstantCash50Enabled: PropTypes.bool.isRequired,
    discountInstantCash80Enabled: PropTypes.bool.isRequired,
    discountInstantCash100Enabled: PropTypes.bool.isRequired,
    discountInstantCash120Enabled: PropTypes.bool.isRequired,
    discountInstantCash150Enabled: PropTypes.bool.isRequired,
    discountInstantCash160Enabled: PropTypes.bool.isRequired,
    discountInstantCash200Enabled: PropTypes.bool.isRequired,
    discountInstantCash250Enabled: PropTypes.bool.isRequired,
    discountInstantCash300Enabled: PropTypes.bool.isRequired,
    discount5OffEnabled: PropTypes.bool.isRequired,
    discount10OffEnabled: PropTypes.bool.isRequired,
    discount15OffEnabled: PropTypes.bool.isRequired,
    discount20OffEnabled: PropTypes.bool.isRequired,
    discount25OffEnabled: PropTypes.bool.isRequired,
    promoGiftCard50Enabled: PropTypes.bool.isRequired,
    promoGiftCard80Enabled: PropTypes.bool.isRequired,
    promoGiftCard100Enabled: PropTypes.bool.isRequired,
    promoGiftCard130Enabled: PropTypes.bool.isRequired,
    promoGiftCard150Enabled: PropTypes.bool.isRequired,
    promoGiftCard200Enabled: PropTypes.bool.isRequired,
    promoGiftCard250Enabled: PropTypes.bool.isRequired,
};

export { LightboxDeals };
